import {
	saveMoreSX,
	separatorSx,
	typoSX,
	verticalSeparatorSx,
} from '@/components/blocks/PromotionCard/styles/PromoIconStyles';

import { PRODUCT_CARD_PROMO_ICONS_IMG_URL } from '@/data/constants/promoIconConstants';
import { useProduct } from '@/data/Content/Product';
import { usePromoMessage } from '@/data/Content/PromoMessage';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { Box, CardMedia, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ComHdmCommercePromoPromotionFetch } from 'integration/generated/custom/data-contracts';

import { FC, useMemo } from 'react';

interface Props {
	partNumber: any;
	saveMore: any;
}

type PromotionDataPercentType = {
	PromotionNam: string;
	active: boolean;
	adminDesc: string;
	baseQty: number;
	endDate: string;
	field1: string;
	field2: string;
	giftCatentries: string[];
	giftQty: number;
	longDesc: string;
	pdpSKU: string;
	physicalStores: string[];
	priority: number;
	promotionId: string;
	relatedCatentries: string[];
	storesType: number;
};
interface PromoIconResponse
	extends Omit<ComHdmCommercePromoPromotionFetch, 'promotionDataPercent'> {
	promotionDataPercent: PromotionDataPercentType;
}
export const SaveMorePromo: FC<Props> = (props) => {
	const { settings } = useSettings();
	const imageServerHostName = settings?.userData?.IMAGE_SERVER_HOSTNAME ?? '';
	const { partNumber } = props;
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const HDMProductDetail = useLocalization('HDMProductDetail');
	const SaveMorePromo = useLocalization('SaveMorePromotion');
	const { product } = useProduct({ id: partNumber });
	const catentryId = product ? product.id : '';
	const { data } = usePromoMessage(catentryId);
	const promoData = data as PromoIconResponse | undefined;

	const promoText = promoData?.promotionDataPercent?.field2 || '';
	const saveMoreValues = useMemo(() => {
		if (!promoText || promoText.trim() === '') return null;
		const priceWithComas = (price: number) =>
			price
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		const promoTextSplitted = promoText.trim().split(' ');
		const saveValues: { [key: string]: string } = {
			buy: promoTextSplitted[1].replace(/\D/g, ''),
			buyGroup: promoTextSplitted[3],
			save: promoTextSplitted[6],
			saveGroup: promoTextSplitted[10],
		};
		saveValues.buy = priceWithComas(parseFloat(saveValues.buy));
		return saveValues;
	}, [promoText]);

	return (
		<>
			<Divider sx={separatorSx} />
			<Stack direction="row">
				<Stack direction="row" sx={saveMoreSX.promoIconContainer}>
					<CardMedia
						image={imageServerHostName + PRODUCT_CARD_PROMO_ICONS_IMG_URL.PROMOICON_CP}
						sx={saveMoreSX.promoIcon}
						title={HDMProductDetail.SaveMore.t()}
						component="img"
					/>
					<Box>
						<Typography variant="body1" component={'p'} sx={typoSX.firstRow}>
							{SaveMorePromo.GetAdditionalSaving.t()}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.secondRow}
						>
							{`${SaveMorePromo.Buy.t()} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.firstRow}
						>
							{`$${saveMoreValues?.buy} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.secondRow}
						>
							{`${SaveMorePromo.in.t()} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.firstRow}
						>
							{`${saveMoreValues?.buyGroup} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.secondRow}
						>
							{`${SaveMorePromo.AndGet.t()} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.firstRow}
						>
							{`${saveMoreValues?.save} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.secondRow}
						>
							{`${SaveMorePromo.Discount.t()} `}
						</Typography>
						<Typography
							variant="bodySubText"
							component={isMobile ? 'p' : 'span'}
							sx={typoSX.firstRow}
						>
							{`${saveMoreValues?.saveGroup} `}
						</Typography>
					</Box>
				</Stack>
				{false ? (
					<>
						<Divider orientation="vertical" flexItem sx={verticalSeparatorSx} />
						<Stack alignItems={'center'} justifyContent={'center'}>
							<Typography variant="bodySubText" component={'span'} sx={saveMoreSX.applyText}>
								{SaveMorePromo.Apply.t()}
							</Typography>
						</Stack>
					</>
				) : null}
			</Stack>
		</>
	);
};
